import { useQuery } from "@tanstack/react-query";
import { likeHeaders } from "@/lib/useLikes";

const API = process.env.REACT_APP_BACKEND_URL;

/** { mine: [{week_start, nickname, total}], latest: {...}|null } — weekly "Champion of the week" trophies. */
export const useTrophies = () => useQuery({
  queryKey: ["trophies"],
  queryFn: async () => { const r = await fetch(`${API}/api/daily/trophies`, { headers: likeHeaders() }); if (!r.ok) throw new Error("trophies"); return r.json(); },
  staleTime: 60_000,
});
